/** Constants and Enums **/

export const SelectedObjectType = {
    Building: 'building',
    SelectionBoxes: 'selectionBoxes'
}

export const ViewMode = {
    District: 'district',
    Orbit: 'orbit',
    Cylinder: 'cylinder',
    FloorPlan: 'floorplan'
}

export const EnvironmentTypes = {
  CesiumEnv: 'cesium',
  CesiumMultiEnv: 'cesium-multi',
  TilesEnv: 'tiles',
  Ground: 'ground',
  Buildings: 'buildings',
  Trees: 'trees',
  BackHouses: 'backHouses',
}

export const CardTypes = {
  Unit: 'unit',
  Options: 'options',
  Amenities: 'amenities',
}

export const FilterTypes = {
    Range: 'range'
}

export const PagesForPagination = {
    Gallery: 'gallery',
    Map: 'map',
    About : 'about',
    Model3D: '3dModel',
    Search: 'search'
}
